
import React, { useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col } from "react-bootstrap";

import ConsultaRegistroDesvios from '../../../../../lib/json/consultas/RegistroDesvios.json'

import LoadingSpinner from "../../../../components/LoadinSpinner";
import InputGeral from "../../../../components/InputGeral/Index";
import { useNavigate, useParams } from "react-router-dom";
import {ConsultaAPI} from "../../../../../backend/ConsultaAPI";
import SubmitForm from "../../../../components/SubmitForm";
import { ConsumoAPI_POST, ConsumoAPI_PUT } from "../../../../../backend/ConsumoAPI";
import { SucessoMsg } from "../../../../contents/VariaveisGlobais";
import { toast } from "react-toastify";

function FichaRegistroDesvios(){
    const navigate = useNavigate();
    // define a exibição do Loading
    var [carregar, setCarregar] = useState(false);
    var [inclusao, setInclusao] = useState(true);

    const { idRegistroDesvios } = useParams();

    // Consulta do grid
    var consultaDefault  = ConsultaRegistroDesvios.consulta + (idRegistroDesvios ? ` WHERE Id = '${idRegistroDesvios}'` : '');

    var [campoDescricao, setCampoDescricao]   = useState([]);

    useEffect(() => {
        if (idRegistroDesvios){
            setInclusao(false)
            loadRegistroDesvios();
        }
    }, []);

    // Processa consulta do grid
    const loadRegistroDesvios = async () => {
        setCarregar(true);
        
        var retConsulta = await ConsultaAPI( consultaDefault );
        
        if (retConsulta.data){
            setCampoDescricao(retConsulta.data[0].Nome);
        }
        
        setCarregar(false);
    }

    const handleSalvar = async() =>{
        try {
            // Verificar se todos os campos obrigatórios foram preenchidos
            if (!campoDescricao) {
                toast.warning('O prenchimento do campo é obrigatório.');
                return;
            }

            setCarregar(true);
            const rota = 'registroDesvios' + (inclusao ? '' : '/' + idRegistroDesvios);
    
            const retConsumo = await (inclusao
                ? ConsumoAPI_POST(rota, { nome: campoDescricao })
                : ConsumoAPI_PUT(rota, { nome: campoDescricao }));
    
            SucessoMsg(retConsumo.description);
        } catch (error) {
            console.error('Error in handleSalvar:', error);
            // Handle the error, show an error message, or log it as needed.
        } finally {
            setCarregar(false);
        }
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage text="Registro de Desvios"/>
            </Col>
            <Col md="12" xs="12">
                <InputGeral 
                    label="Descrição"
                    tipo='text'
                    value={campoDescricao}  // Define o valor do campo com base no estado
                    onChange={(e) => setCampoDescricao(e.target.value)}
                />
            </Col>
        </Row>
        
        <SubmitForm onSave={handleSalvar} onCancel={"handleCancelar"}></SubmitForm>
        </>
    );
}

export default FichaRegistroDesvios;